<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6">
        <h1>Login</h1>
        <v-form>
          <v-text-field v-model="email" label="E-Mail" outlined></v-text-field>
          <v-text-field v-model="password" label="Passwort" type="password" outlined></v-text-field>
          <v-btn block color="primary" @click="login">Anmelden</v-btn>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      email: '',
      password: '',
    };
  },
  methods: {
    async login() {
      try {
        const response = await axios.post('https://bossel.fluidmans.de/bosseln-app-backend/api/auth/login', {
          email: this.email,
          password: this.password,
        });
        if (response.status === 200) {
          localStorage.setItem('isAuthenticated', 'true');
          this.$router.push('/');
        }
      } catch (error) {
        alert('Anmeldung fehlgeschlagen. Überprüfe deine Eingaben.');
      }
    },
  },
};
</script>
